(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/draws-redux/assets/javascripts/draws-services.js') >= 0) return;  svs.modules.push('/components/sport/draws-redux/assets/javascripts/draws-services.js');
"use strict";


const {
  jupiter,
  log
} = svs.core;
const {
  products
} = svs.utils;
const {
  ApiProxy,
  http,
  featureToggle
} = svs.components.lbUtils.apiProxy;
const logger = log.getLogger('draws-redux:fetchDrawsPromise');
const {
  FetchState
} = svs.components.sport.drawsRedux;
const STATE_FULFILLED = FetchState.Fulfilled.toLowerCase();
const cloudApiFeatureToggles = svs.components.lbUtils.cloudApi.cloudApiConstants;
const fetchOpenedDrawsPromise = async (drawAPIPath, req) => {
  const customHandler = http.get("/draw/1/:product/draws", _ref => {
    let {
      data
    } = _ref;
    return data;
  }, {
    config: {
      shouldUseCloud: async () => {
        const isEnabled = await featureToggle(cloudApiFeatureToggles[drawAPIPath.toUpperCase()], {
          req
        });
        return isEnabled;
      },
      allowedProducts: ['bomben', 'matchen', 'europatipset', 'stryktipset'],
      cloudEndpointTemplate: '/v1/:product/draws'
    }
  });
  const apiProxy = new ApiProxy([customHandler]);
  const response = await apiProxy.fetch("/draw/1/".concat(drawAPIPath, "/draws"), {
    method: 'GET',
    req
  });
  return response.draws;
};
const fetchDrawsPromise = async function (productId, drawNumber) {
  let shouldFetchJackpot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const customHandler = http.get('/draw/1/:product/draws/:drawNumber', _ref2 => {
    let {
      data
    } = _ref2;
    return data;
  }, {
    config: {
      shouldUseCloud: async options => {
        const isEnabled = await featureToggle(cloudApiFeatureToggles[options.productName.toUpperCase()], {
          req: undefined
        });
        return isEnabled;
      },
      allowedProducts: ['bomben', 'matchen', 'europatipset', 'stryktipset'],
      cloudEndpointTemplate: '/v1/:product/draws/:drawNumber'
    }
  });
  const drawUrls = [];
  const jackpotUrls = [];
  drawNumber.forEach(draw => {
    const productName = products.getSpecificDrawName(productId);
    drawUrls.push({
      url: "/draw/1/".concat(productName, "/draws/").concat(draw),
      productName
    });
    shouldFetchJackpot && jackpotUrls.push(encodeURIComponent("/draw/1/jackpot/draws?product=".concat(productName, "&drawNumber=").concat(draw)));
  });
  const apiProxy = new ApiProxy([customHandler]);
  const allDrawsPromises = drawUrls.map(drawUrl => apiProxy.fetch(drawUrl.url, {
    method: 'GET',
    productName: drawUrl.productName
  }));
  const drawsResponse = await Promise.allSettled(allDrawsPromises);
  let jackpotResponse;
  if (shouldFetchJackpot && jackpotUrls.length > 0) {
    jackpotResponse = await jupiter.get(jackpotUrls);
  }
  const jackpots = [];
  const draws = {
    draws: [],
    rejectedDraws: []
  };
  drawsResponse.forEach(drawResponse => {
    if (drawResponse.status === STATE_FULFILLED) {
      if (drawResponse.value.error) {
        logger.info("Error fetching draws and/or jackpots, error: ".concat(drawResponse.value.error));
        draws.rejectedDraws.push(drawResponse.value);
      } else {
        draws.draws.push(drawResponse.value);
      }
    }
    if (drawResponse.status === 'rejected') {
      logger.info("Error fetching draws and/or jackpots, error: ".concat(drawResponse.reason));
      draws.rejectedDraws.push({
        error: drawResponse.reason
      });
    }
  });
  jackpotResponse && jackpotResponse.responses.forEach(value => {
    jackpots.push(value);
  });
  return [draws, jackpots];
};
const fetchNetSalePromise = async _ref3 => {
  let {
    productId
  } = _ref3;
  const filterIncludes = ['draws.currentNetSale',
  'draws.currentNetSales', 'draws.drawNumber', 'draws.productId'];
  const url = "/draw/1/".concat(products.getDrawName(productId), "/draws/light?include=").concat(filterIncludes.join(','));
  const apiProxy = ApiProxy.create();
  const response = await apiProxy.fetch(url, {
    method: 'GET'
  });
  let draws = [];
  if (response.error) {
    logger.info("Error fetching netSales, error: ".concat(response.error));
  } else {
    draws = response.draws;
  }
  return draws;
};
setGlobal('svs.components.sport.drawsRedux.services', {
  fetchDrawsPromise,
  fetchOpenedDrawsPromise,
  fetchNetSalePromise
});

 })(window);